import * as React from 'react';
import classnames from 'classnames';
import { Heading } from '@grandvisionhq/elements';
import { Select } from '@grandvisionhq/forms';
import { useIntl } from '@grandvisionhq/state';
import '@grandvisionhq/analytics';
import '../../../../context/actions.js';
import '../../../../context/reducer.js';
import '../../../../types/product.js';
import '../../../../context/ProductContext.js';
import '../../../../context/CmsContext.js';
import '@swc/helpers';
import { pushDeliveryIntervalSelectionEvent } from '../../../Analytics/events/subscription-events.js';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/utils';
import '@grandvisionhq/graphql';
import '@grandvisionhq/svc-tealium/utils';

const DeliveryIntervalSelect = /*#__PURE__*/ React.memo(({ className , hasError , deliveryIntervalOptions , selectedInterval , onIntervalSelection  })=>{
    const { getLabel  } = useIntl();
    const title = getLabel('products.subscriptions.deliveryInterval.title');
    const handleIntervalSelection = React.useCallback((interval)=>{
        pushDeliveryIntervalSelectionEvent(interval);
        onIntervalSelection(interval);
    }, []);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('delivery-interval-select', className)
    }, /*#__PURE__*/ React.createElement(Heading, {
        className: "delivery-interval-select__title",
        variant: "smallest",
        component: "h3"
    }, title), /*#__PURE__*/ React.createElement(Select, {
        placeholder: getLabel('products.subscriptions.deliveryInterval.placeholder'),
        id: "delivery_interval_select",
        name: "delivery_interval_select",
        options: deliveryIntervalOptions,
        initialState: selectedInterval,
        onChange: handleIntervalSelection,
        "aria-invalid": hasError,
        "aria-label": title,
        required: true,
        "data-t": "delivery-interval-select"
    }));
});

export { DeliveryIntervalSelect };
//# sourceMappingURL=DeliveryIntervalSelect.js.map
